<div class="policy" [class.is-active]="policy">
    <div class="policy__title">Terms and Creative Content Policy</div>
    <perfect-scrollbar class="scroll-container" style="height: 154px;">
        <div class="policy__text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla pulvinar ultrices dictum. Curabitur pretium eu nulla vel convallis. Nam a sapien non velit sodales cursus vitae at velit. Donec Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla pulvinar ultrices dictum. Curabitur pretium eu nulla vel convallis. Nam a sapien non velit sodales cursus vitae at velit. Donec</div>
    </perfect-scrollbar>
    <button class="policy__close" (click)="hidePolicy()">Close</button>
</div>
